/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_Error_TitleInputs */

const es_feedback_delete_error_title = /** @type {(inputs: Feedback_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos eliminar el feedback`)
};

const en_feedback_delete_error_title = /** @type {(inputs: Feedback_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't delete the feedback`)
};

/**
* | output |
* | --- |
* | "We couldn't delete the feedback" |
*
* @param {Feedback_Delete_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_error_title = /** @type {((inputs?: Feedback_Delete_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_error_title(inputs)
	return en_feedback_delete_error_title(inputs)
});
export { feedback_delete_error_title as "feedback.delete.error_title" }